module.exports = __webpack_public_path__ + "img/shipping-incomplete.e00b3e38.svg";